import React, { createContext, useContext } from 'react'

export const ROLES = {
  CEO: { id: 'nLSSLch316I', label: 'Director Goals and Objectives' },
  HOD: { id: 'adeqQmxfCLF', label: 'Department Heads Objectives' },
  TOP_STAFF: { id: 'gtMJNK0QVL7', label: 'Top Staff Objectives' },
  SENIOR_STAFF: { id: 'vdVjNaqxblC', label: 'Senior Staff Objectives' },
  ADMIN: { id: 'R3lFolCMdoi', label: 'Admin' },
  GUEST: { id: 'Guest', label: 'Guest' },
}

const UserRoleContext = createContext()


export function UserRoleProvider({ children, role }) {
  return (
    <UserRoleContext.Provider value={{ role }}>
      {children}
    </UserRoleContext.Provider>
  );
}


export function useUserRole() {
  const context = useContext(UserRoleContext);
  if (!context) {
    throw new Error('useUserRole must be used within a UserRoleProvider');
  }
  return context;
}